<ng-container *ngIf="size != 'default'">
    <ng-container [ngSwitch]="size">
        <ng-container *ngSwitchCase="'mobile'">
            <div class="display-container">
                <div class="mobile">
                    <iframe src="http://localhost:4200/responsive" #iframe (load)="onLoad(iframe)">

                    </iframe>
                </div>

            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'laptop'">
            <div class="display-container">
                <div class="laptop">
                    <iframe src="http://localhost:4200/responsive" #iframe (load)="onLoad(iframe)">

                    </iframe>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
<ng-container *ngIf="size == 'default'">
    <ng-template #previewHost kveRenderCell [section]="section" [activeSelector]="activeSelector"
        [rendererComponent]="rendererComponent" [selectedCell]="selectedCell" [selectedTabTitle]="selectedTabTitle"
        [posChange]="posChange" [cellId]="cellId"></ng-template>
</ng-container>